module.exports = __webpack_public_path__ + "static/media/financeIco.6791cad1.svg";